import { Grid } from 'components/grid/grid';
import { wccModules } from 'enums/wccModules';
import { ThreadMedia } from 'interfaces/threadMedia';
import { inject, injectable } from 'inversify';
import { Subscribable, SubscribableOrNullableValue } from 'knockout';
import TopicMediaManager from 'managers/topic/media';
import WCCAttachment from 'models/attachments/attachment';
import WCCAudio from 'models/attachments/audio';
import './threadMedia.html';
import './threadMedia.scss';

components.preload('grid-new', 'wcc-audio', 'wcc-generic-attachment', 'attachment-controls', 'wcc-image', 'attachment-title-editor', 'wcc-video', 'attachment-caption', 'wcc-file', 'wcc-upload');

export interface ThreadMediaVMConfig {
    media: SubscribableOrNullableValue<TopicMediaManager>
    mediaSize: SubscribableOrNullableValue<number>
    captionEditor: SubscribableOrNullableValue<boolean>
}

@injectable()
export default class ThreadMediaVM {
    private mediaManager: Subscribable<TopicMediaManager | undefined>

    id = _.uniqueId(`thread-media-`);

    mediaGrid: Grid<ThreadMedia>
    audioGrid: Grid<WCCAudio>

    hasMedia: Subscribable<boolean>
    hasAudio: Subscribable<boolean>

    isCaptionEditorNeeded: Subscribable<boolean>

    constructor(
        @inject(wccModules.componentConfig) config: ThreadMediaVMConfig,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo,
    ) {
        this.mediaManager = ko.flattenComputed(config.media);
        const mediaSize = ko.flattenComputed(config.mediaSize, 150);
        this.isCaptionEditorNeeded = ko.flattenComputed(config.captionEditor, false);

        const attachments = this.mediaManager.pluck(m => m.attachments, []);
        const uploads = this.mediaManager.pluck(m => m.uploads, []);        

        const mainAttachmentes = attachments.filter(a => !a.isAudio());
        const audios = attachments.filter<WCCAudio>(a => a.isAudio());        

        const media = ko.pureComputed(() => (<Array<ThreadMedia>>mainAttachmentes()).concat(uploads()));

        this.mediaGrid = new Grid({
            source: media,
            columnWidth: mediaSize,
            offset: 5,
            threshold: 50
        });

        this.hasMedia = media.any();
        
        this.audioGrid = new Grid({
            source: audios,
            offset: 5
        });

        this.hasAudio = audios.any();

        ko.applyBindingsToNode(info.element, {
            'css': {
                'thread-media': true
            }
        });
    }

    removeAttachment = (attachment: WCCAttachment) => {
        this.mediaManager()?.removeAttachment(attachment);
    }
}